



















































































































































































import { Component, Vue, Prop, Watch } from "vue-property-decorator";
import BaseVue from "@/core/BaseVue";
import TramiteBeneficiario from "@/models/tramite/tramiteBeneficiario.model";
import TipoTramite, {
  ComponentImportConfig,
  ComponentDesignConfig
} from "@/models/tipoTramite";
import NameValue from "@/models/nameValue.model";
import Persona from "@/models/persona/persona.model";
import Beneficiario from "@/models/beneficiario/beneficiario.model";
import BTableConfig from "@/core/BTableConfig/BTableConfig";
import TramiteBeneficiarioDocumento from "@/models/tramite/tramiteBeneficiarioDocumento.model";
import BTableColumn from "@/models/base/BTableColumn.model";
import { RowTable } from "@/typings/BRowTable";
import BaseRepository from "@/core/HttpResources/BaseRepository";
import TramiteNovedad from "../../models/tramite/tramite-novedad.model";
@Component({
  name: "tramiteBeneficiarioResumen"
})
export default class TramiteBeneficiarioContentComponent extends BaseVue {
  @Prop() readonly value!: number;
  @Prop() readonly solicitante!: Persona;
  @Prop() readonly origen!: NameValue;
  @Prop() readonly estado!: NameValue;
  @Prop() readonly beneficiario!: Beneficiario;
  @Prop() readonly beneficiarioPersona!: Persona;
  @Prop() readonly prioridad!: NameValue;
  @Prop() readonly tipoTramite!: TipoTramite;
  @Prop() readonly solicitud!: TramiteBeneficiario;
  @Prop() readonly tipoDocumentos!: any[];
  @Prop() readonly showDocs!: boolean;
  @Prop() readonly serverSide!: boolean;

  model = new TramiteBeneficiario();
  loading = false;
  get userId() {
    return this.m_solicitud.asignadoId || this.$store.state.user.id;
  }
  get tramiteBeneficiarioId() {
    return this.value || this.m_solicitud.id;
  }
  get m_tipoTramite() {
    return (
      this.tipoTramite || this.m_solicitud.tipoTramite || new TipoTramite()
    );
  }
  get m_solicitante() {
    return this.solicitante || this.m_solicitud.persona || new Persona();
  }
  get m_prioridad() {
    return this.prioridad || this.m_solicitud.prioridad || new NameValue();
  }
  get m_estado() {
    return this.estado || this.m_solicitud.estado || new NameValue();
  }

  get m_beneficiario() {
    return (
      this.beneficiario || this.m_solicitud.beneficiario || new Beneficiario()
    );
  }
  get m_beneficiarioPersona() {
    return (
      this.beneficiarioPersona ||
      (this.m_solicitud.beneficiario
        ? this.m_solicitud.beneficiario.persona
        : new Persona())
    );
  }
  get m_origen() {
    return this.origen || this.m_solicitud.origen || new NameValue();
  }

  get m_tipoDocumentos() {
    return this.tipoDocumentos || this.m_solicitud.documentos || [];
  }
  get m_solicitud() {
    return this.solicitud || this.model || new TramiteBeneficiario();
  }
  created() {
    if (this.serverSide) this.getData();
  }

  get includes() {
    let data = [];
    data.push(
      "Origen",
      "Estado",
      "Prioridad",
      "TipoTramite",
      "Beneficiario.Persona",
      "Persona",
      "Asignado.Persona"
    );
    return data.join("|");
  }
  async getData() {
    try {
      this.loading = true;
      this.model = await new BaseRepository<TramiteBeneficiario>(
        "tramitebeneficiario"
      ).one(`id=${this.tramiteBeneficiarioId}`, this.includes);
    } catch (errors) {
      this.operationFailedErrors(errors);
    } finally {
      this.loading = false;
    }
  }
  @Watch("value")
  onModelChange(val: number) {
    if (val) this.getData();
  }
  get totalNovedades() {
    return this.novedades.length;
  }
  get novedadesValue() {
    return (this.novedadesCompletadas / this.totalNovedades) * 100;
  }
  get novedadesAbiertas() {
    return this.novedades.filter(x => x.estado === 0).length;
  }
  get novedadesCreadas() {
    return this.novedades.filter(x => x.estado === 1).length;
  }
  get novedadesEnProceso() {
    return this.novedades.filter(x => x.estado === 2).length;
  }
  get novedadesCompletadas() {
    return this.novedades.filter(x => x.estado === 3).length;
  }
  get novedadesRechazadas() {
    return this.novedades.filter(x => x.estado === 4).length;
  }
  get novedadesFinalizadas() {
    return this.novedades.filter(x => x.estado && x.estado > 2).length;
  }
  getEstadoColor(codigo: string) {
    if (codigo === "Completado") return "success";
    if (codigo === "Rechazado") return "danger";
    if (codigo === "Creado") return "primary";
    if (codigo === "EnProceso") return "info";
    if (codigo === "Abierto") return "dark";
    if (codigo === "Cerrado") return "black";
  }
  novedades: TramiteNovedad[] = [];
  onNovedadesChange(nov: TramiteNovedad[]) {
    this.novedades = nov;
  }
  tipoTramiteConfig:
    | ComponentImportConfig
    | ComponentDesignConfig
    | null = null;
  get isComponentImported() {
    if (!this.m_tipoTramite) return false;
    return this.m_tipoTramite.componentImported && !!this.tipoTramiteConfig;
  }
  get isComponentDesigned() {
    if (!this.m_tipoTramite) return false;
    return this.m_tipoTramite.componentDesigned && !!this.tipoTramiteConfig;
  }
  componentImportedRepo = new BaseRepository<ComponentImportConfig>(
    "ComponentImportConfig"
  );
  componentDesignedRepo = new BaseRepository<ComponentDesignConfig>(
    "ComponentDesignConfig"
  );
  componentDesigConfig!: ComponentDesignConfig;
  @Watch("m_tipoTramite")
  async onTipoTramiteChange(value: TipoTramite | null) {
    this.tipoTramiteConfig = null;
    if (value) {
      if (value.componentImported) {
        this.loading = true;
        this.tipoTramiteConfig = await this.componentImportedRepo.one(
          `id=${value.componentImportConfigId}`,
          "Properties"
        );
        this.loading = false;
        return;
      }

      if (value.componentDesigned) {
        this.loading = true;
        this.tipoTramiteConfig = await this.componentDesignedRepo.one(
          `id=${value.componentDesignConfigId}`,
          "Attributes.Attributes.Attributes.Attributes|Attributes.Parent"
        );
        this.componentDesigConfig = this.map<ComponentDesignConfig>(
          this.tipoTramiteConfig
        );
        this.loading = false;
        return;
      }
    }
  }
  get componentImportedProps() {
    let result: any = {};
    if (!this.isComponentImported) return result;

    //Todo GET PROFILE ATTRIBUTES VALUES
    (this.tipoTramiteConfig as ComponentImportConfig).properties.forEach(x => {
      if (x.isStaticValue) result[x.name as string] = x.staticValue;
    });
    return result;
  }
  /*
    getDescripcionFormatted(descripcion: string) {
      let corte = 130; // 150 -> cantidad de caracteres cercana a la maxima para que se alargue el diseño.
      let stringFormatted = "";
      let iteraciones = Math.ceil(descripcion.length / corte);
      for (let i = 0; i < iteraciones; i++) {
        let aux = "";
        if (i === 0) aux = descripcion.substring(i, corte);
        else aux = descripcion.substring(corte * i, corte * (i + 1));
        stringFormatted += `${aux} <br/>`;
      }
      return `<span style="text-align: justify;"> ${stringFormatted} </span>`;
    }
  */
}
